// Copyright (c) 2025 Bytedance Ltd. and/or its affiliates
// SPDX-License-Identifier: MIT

import { GithubFilled, GoldenFilled, GoldFilled, PlayCircleFilled, RocketFilled, StarFilled } from "@ant-design/icons";
import Link from "next/link";
import { useState } from "react";

import { AuroraText } from "@/components/magicui/aurora-text";
import { Button } from "@/components/ui/button";

import { SectionHeader } from "../components/section-header";
import AuthLoginForm from "@/components/AuthLoginForm";
import AuthRegisterForm from "@/components/AuthRegisterForm";
import AuthLogout from "@/components/AuthLogout";

export function JoinCommunitySection() {
  return (
    <section className="flex w-full flex-col items-center justify-center pb-12">
      <SectionHeader
        anchor="join-community"
        title={
          <AuroraText colors={["#60A5FA", "#A5FA60", "#A560FA"]}>
            Enjoin the BioAgent
          </AuroraText>
        }
        description="Contribute brilliant ideas to shape the future of BioAgent. Collaborate, innovate, and make impacts."
      />
      {/* <Button className="text-xl mt-8" size="lg" asChild>
        <Link href= "http://www.bennyyu.cn:3002/chat" >
          <PlayCircleFilled />
          Get Started
        </Link>
      </Button> */}
    </section>
  );
}
